(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .factory('action-form-clear-validation', actionFunc);

    function actionFunc($q, FormBuilderService, lodash) {
        return function(options, evtData, actionResponse) {
            $q.when(run());

            function run() {
                const formId = lodash.get(options, 'formId', false);
                if (!formId) return false;

                const fbService = FormBuilderService.get(formId);
                fbService.elementsService.setValidationRules({}, '', true);

                return true;
            }
        };
    }
})();